/* CARROUSEL */
class Carrousel {
  constructor(elem){
    this.element = elem;
    this.itemsNode = this.element.querySelector("items");
    this.items = this.element.querySelectorAll("item");
    this.mayLoop = true;
    this._currentItem = 0;
    this._animationDelay = parseInt(this.element.getAttribute("autoplay")) || 0;

    if(this.element.querySelector("button[type='prev']")){
      this.assign(this.element.querySelector("button[type='prev']"), () => this.prev());
    }
    if(this.element.querySelector("button[type='next']")){
      this.assign(this.element.querySelector("button[type='next']"), () => this.next());
    }

    let originPos = this._currentItem * this.getItemsWidth();
    window.requestAnimationFrame(() => {
      this.itemsNode.scrollTo(originPos, 0);
    });

    const dragSensibility = 9;

    // Drag on desktop
    const dragActionDesktop = event => {
      this.itemsNode.scrollBy((event.movementX * (-dragSensibility)), 0);
    }

    this.itemsNode.addEventListener("mousedown", e => {
      this.itemsNode.addEventListener("mousemove", dragActionDesktop);
    });
    this.itemsNode.addEventListener("mouseup", e => {
      this.itemsNode.removeEventListener("mousemove", dragActionDesktop);
      let closestItem = Math.round(this.itemsNode.scrollLeft / this.getItemsWidth());
      this._currentItem = closestItem;
      this.jumpToCurrentItem();
    });

    // Drag on mobile
    const dragActionMobile = event => {
      let targetPosX = (this.items[this._currentItem].offsetLeft) + (this._initPageX - event.changedTouches[0].pageX);
      this.itemsNode.scroll(targetPosX, 0);
    }
    
    this.itemsNode.addEventListener("touchstart", e => {
      this._initPageX = e.changedTouches[0].pageX;
      this.itemsNode.style.scrollBehavior = "auto";
      this.itemsNode.addEventListener("touchmove", dragActionMobile);
    });

    this.itemsNode.addEventListener("touchend", e => {
      this.itemsNode.removeEventListener("touchmove", dragActionMobile);
      let closestItem = Math.round(this.itemsNode.scrollLeft / this.getItemsWidth());
      this._currentItem = closestItem;
      this.itemsNode.style.scrollBehavior = "smooth";
      this.jumpToCurrentItem();
    });
  }

  getItemsWidth(){
    return this.items[0].clientWidth;
  }

  assign(elem, action){
    elem.addEventListener("click", action);
  }

  prev(){
    if(this._currentItem > 0){
      if(this.items[this._currentItem].offsetLeft > this.itemsNode.scrollLeft){
        while(this.items[this._currentItem].offsetLeft > this.itemsNode.scrollLeft){
          this._currentItem --;
        };
      } else {
        this._currentItem --;
      }
      this.jumpToCurrentItem();
    } else if(this.mayLoop) {
      this._currentItem = this.items.length - 1;
      this.jumpToCurrentItem();
    }
  }

  next(){
    let scrollLeftMax = this.itemsNode.scrollWidth - this.itemsNode.clientWidth - this.itemsNode.scrollLeft;
    // alert(scrollLeftMax);
    if(this._currentItem < (this.items.length - 1) && scrollLeftMax > 0){ // && this.itemsNode.scrollLeft < this.itemsNode.scrollLeftMax
      this._currentItem ++;
      this.jumpToCurrentItem();
    } else if(this.mayLoop) {
      this._currentItem = 0;
      this.jumpToCurrentItem();
    }
  }

  jumpToCurrentItem(){
    let target = this.items[this._currentItem].offsetLeft;
    this.itemsNode.scrollTo(target, 0);
  }
}

const carrouselObj = {"found":0, "success":0, "errors":0, "instances":[]}
for(let carrousel of document.querySelectorAll("carrousel")){
  carrouselObj.found++;
  if(carrouselObj.instances[carrouselObj.instances.length] = new Carrousel(carrousel)){
    carrouselObj.success++;
  } else {
    carrouselObj.errors++;
  };
}
